export default (store) => ({
  layout: { fluid: true },
  path : '/menu/:kitchenSlug(/:tab)(/:entityId)(/:entityTab)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'MenuDetails' */
      './components/MenuDetails'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
